import React from "react";
import { RiDashboardFill } from "react-icons/ri";
import { GiOrganigram } from "react-icons/gi";
import { ImPhone } from "react-icons/im";
import { ImDisplay } from "react-icons/im";
import { ImList } from "react-icons/im";
import { IoPeopleSharp, IoPeopleCircleOutline } from "react-icons/io5";
import { SimpleGrid } from "@chakra-ui/react";

import { useUser } from "context/user";
import { UserRole } from "types/user";
import NavLink from "./NavLink";

const PrimaryNav: React.FC = () => {
  const { user } = useUser()!;

  return (
    <SimpleGrid as="nav" columns={{ base: 1, sm: 2, xl: 1 }} gap={2}>
      <NavLink
        label="Dashboard"
        icon={RiDashboardFill}
        to="/dashboard"
        highlightLocation
      />
      <NavLink
        label="Sessions"
        icon={ImPhone}
        to="/sessions"
        highlightLocation
      />
      <NavLink
        label="Training"
        icon={ImDisplay}
        to="/training"
        highlightLocation
      />
      <NavLink
        label="Clients"
        icon={IoPeopleSharp}
        to="/clients"
        highlightLocation
      />
      <NavLink
        label="Coaches"
        icon={IoPeopleCircleOutline}
        to="/coaches"
        highlightLocation
        hidden={user.privs < UserRole.OrgAdmin}
      />
      <NavLink
        label="Organizations"
        icon={GiOrganigram}
        to="/organizations"
        highlightLocation
        hidden={user.privs < UserRole.OrgAdmin}
      />
      <NavLink
        label="Update Notes"
        icon={ImList}
        to="/changes"
        highlightLocation
      />
    </SimpleGrid>
  );
};

export default PrimaryNav;
